
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as legislationB7xHGN4o2fNTeFAE6etv8YXINQEcv9x7l__tiEV0X9QMeta } from "/opt/build/repo/app/pages/profile/signature-standards/update/legislation.vue?macro=true";
import { default as confirmS3vMEB7vO9kGKCAD9FA4WJkj93KWHbXKJEjuknw5w5MMeta } from "/opt/build/repo/app/pages/signup/flows/eidplus/confirm.vue?macro=true";
import { default as newQlfMnFfLDaekn69AF6Q1JpStnyNocJYgQQCHD4yrhtcMeta } from "/opt/build/repo/app/pages/signup/flows/eidplus/new.vue?macro=true";
import { default as plantN0keAE_AxfkqlvqBGvIp0zknrmv_TZwxGbbr1Z7mXQMeta } from "/opt/build/repo/app/pages/business/billing/plan.vue?macro=true";
import { default as api4dTCji_tursDItEokb32onoQLeQ97ZaWz9UAEm4YwAwMeta } from "/opt/build/repo/app/pages/business/developers/api.vue?macro=true";
import { default as domainsS_JEYm9DIccJkePnUq_RPlAz1YhjNOijNoNpXt7vkzYMeta } from "/opt/build/repo/app/pages/business/members/domains.vue?macro=true";
import { default as groupsT8ez152GUsY2bCL5T9bCQTRykX4BjyDr_G5danX7aI0Meta } from "/opt/build/repo/app/pages/business/members/groups.vue?macro=true";
import { default as aes_45for_45businessjizLbRHnLftjLxbX1uNK0rnO6PDeMylR968o21f3jj0Meta } from "/opt/build/repo/app/pages/business/profile/aes-for-business.vue?macro=true";
import { default as mail_45senth3moUOXBNXRa8eYo5VELEl584pBpA76HnfFgGMmssnIMeta } from "/opt/build/repo/app/pages/business/signup/mail-sent.vue?macro=true";
import { default as stepsFUX3gLZ95tsbuEXVA8B_jOVOd4yF1_InqDkpEYz1vVUMeta } from "/opt/build/repo/app/pages/business/signup/steps.vue?macro=true";
import { default as loginMaJG6opKGuJmnX7gWF5WIZx_849AebqLX5ZxFowE58cMeta } from "/opt/build/repo/app/pages/ph/oauth2/login.vue?macro=true";
import { default as indexyemt9ppC3LdvMx2eu3vH8vS3V13Ge6F_QsYQvaWGDhIMeta } from "/opt/build/repo/app/pages/profile/signature-standards/update/index.vue?macro=true";
import { default as companydT69o49JGr4fQaptA6qKskY6vqbuX20AY_qcK8Aq8xMMeta } from "/opt/build/repo/app/pages/sso/error/company.vue?macro=true";
import { default as legislationqH81e0LrmF_bef2OyemwRvJLhpD8L1sxGGY4BS5FCNwMeta } from "/opt/build/repo/app/pages/direct-sign/identification/[id]/[userid]/legislation.vue?macro=true";
import { default as previewLPohnTB6589hVv8MmENilR_28aQVunSQDSXguvIhY_YMeta } from "/opt/build/repo/app/pages/direct-sign/identification/[id]/[userid]/preview.vue?macro=true";
import { default as indexlWods5XMAO30KVvusm6ZvvrTw8THq3pKXLFvoLyhxAsMeta } from "/opt/build/repo/app/pages/direct-sign/identification/[id]/[userid]/index.vue?macro=true";
import { default as index7IoUENXGpqrrdwsIzkKDTzrNr54I9QyqfzXthXKkJ7YMeta } from "/opt/build/repo/app/pages/business/seals/[sealName]/index.vue?macro=true";
import { default as activityROuL03qpCWh55jKw8KhbMce19SA9ZlZ5VyN_X4TKMegMeta } from "/opt/build/repo/app/pages/business/activity.vue?macro=true";
import { default as dashboardJ_1_vtphZ_4VzI3vYVyrs50L67VxLNQse_0lXAcdJU0Meta } from "/opt/build/repo/app/pages/business/dashboard.vue?macro=true";
import { default as document3773Wnvz_u2NlCR5DoaV3rWchUeCzahGENK2O4KY8DYMeta } from "/opt/build/repo/app/pages/business/document.vue?macro=true";
import { default as emailsmxFS8MytxBofyYkSf5ns5tygHQppqeYKPLlt0Qeh_gIMeta } from "/opt/build/repo/app/pages/business/emails.vue?macro=true";
import { default as indexSkKyvbmHmfhpqPR5a4UFe0LVll3rR0LhEuqS1oaAOOMMeta } from "/opt/build/repo/app/pages/business/extras/index.vue?macro=true";
import { default as indexTZMsL7l7elYVLtWnL6aoAEHosphB_oNrEF9l5_KeDZ0Meta } from "/opt/build/repo/app/pages/business/members/index.vue?macro=true";
import { default as index1Wyi6_rtlA2LSrM2UtLB_Mn9VY6Mh94fLaOK6IRyJTMMeta } from "/opt/build/repo/app/pages/business/profile/index.vue?macro=true";
import { default as indexkwwdiWe3omfo9IOyv_hL57560B0_3SL5k3Jqxp6M0KMMeta } from "/opt/build/repo/app/pages/business/register/index.vue?macro=true";
import { default as indexPWG6FpuX9nBE1hF2hCqQ8v0x3b8tGk09Oo3g1rKXU7QMeta } from "/opt/build/repo/app/pages/business/seals/index.vue?macro=true";
import { default as indexA_ZNRxEgO0N2PCbq166XTDdFgBuy9PhPVuORc0Ci4gEMeta } from "/opt/build/repo/app/pages/business/signup/index.vue?macro=true";
import { default as upgrade1vDoNUkm30P_dTERr2wSkAzF_At0JUzwFCCZlbqNzCYMeta } from "/opt/build/repo/app/pages/business/upgrade.vue?macro=true";
import { default as welcomebhNxlhDiu7xxZiLYo9PZ4_u06FeEW_P7ulzRlrGPRO0Meta } from "/opt/build/repo/app/pages/business/welcome.vue?macro=true";
import { default as redirectj2uDdkxIVHXABqZTbZWfbzd6jwrP5WAKJK0E0Q_ePAYMeta } from "/opt/build/repo/app/pages/mab/redirect.vue?macro=true";
import { default as redirect_45identiV2HR8MNR0BGj5b6EQKhH75yFioskMt5snaT6wi3U_IMeta } from "/opt/build/repo/app/pages/mab/redirect-ident.vue?macro=true";
import { default as confirm_LylbhKtP_Q_d2NYPB0dX7Ne6MZkSJYke5cKm6cOa6IMeta } from "/opt/build/repo/app/pages/password-reset/confirm.vue?macro=true";
import { default as mail_45sentb_W1BbAqJJ2B06XPLGRjjYdD5e9Sd0c2qHd_G9MnE0IMeta } from "/opt/build/repo/app/pages/password-reset/mail-sent.vue?macro=true";
import { default as new64QfEf_N3xlluf_a6HOiq1_3niD8x4Cl0lCYbjGDQFsMeta } from "/opt/build/repo/app/pages/password-reset/new.vue?macro=true";
import { default as change_45passwordnXlavpNCIWga8k4arM6wsPhbipAePLOA6KIPDOGodX4Meta } from "/opt/build/repo/app/pages/profile/change-password.vue?macro=true";
import { default as confirmeRm5AU7EyBPGVdDb6Kg6__y_pbeD6Hd6mgqqruQVcNAMeta } from "/opt/build/repo/app/pages/profile/confirm.vue?macro=true";
import { default as settingsk2wl4ftyrvYKnjCI5Mgi_p4ltFfzdC06QKqVKwBgi6UMeta } from "/opt/build/repo/app/pages/profile/settings.vue?macro=true";
import { default as indexw8qEYFGX2Ed8XSCZojzZaTMPRbKDeGiM6XQxoXrSXjoMeta } from "/opt/build/repo/app/pages/profile/signature-standards/index.vue?macro=true";
import { default as visual_45signature6xNFbiUTpmWEFWQrpeEtizvKDHNfCjRHolj_xcYgkjYMeta } from "/opt/build/repo/app/pages/profile/visual-signature.vue?macro=true";
import { default as confirm45xOteHgwbcOFGnDIApqnniVSM_O7jMXLmcrijrtdHYMeta } from "/opt/build/repo/app/pages/signup/confirm.vue?macro=true";
import { default as mail_45sentiSdN6bqcb6ysDQ3B9CNCNFkiawaEo9xGtmjv0TQ_iHsMeta } from "/opt/build/repo/app/pages/signup/mail-sent.vue?macro=true";
import { default as ssoFfrxxRpULCuYoytW4yTfXh_e_G4KQ6Xy_xranu5frZkMeta } from "/opt/build/repo/app/pages/signup/sso.vue?macro=true";
import { default as indexSXhqIe3gXX2XTh5AdmbvZ6BMu21pWxM1FJWjg7hDGb4Meta } from "/opt/build/repo/app/pages/signup/starter/index.vue?macro=true";
import { default as stepsPGOW6gaf3jzTsv48e68HfiDHhBezwcgspo4wWmO3Jq8Meta } from "/opt/build/repo/app/pages/signup/steps.vue?macro=true";
import { default as indexxi1YGsm8LBuD4U6hkxyi3VA21_mjzYpmTBdlzZ33t2sMeta } from "/opt/build/repo/app/pages/sso/error/index.vue?macro=true";
import { default as indexLqy26eFGIrE_oImypaxaw74IxlL7HEKg_eepufJdPscMeta } from "/opt/build/repo/app/pages/starter/register/index.vue?macro=true";
import { default as indexPnsekB5wUISULu1ger1g7EE89aa9uBOxXSy9p2Z66gIMeta } from "/opt/build/repo/app/pages/view/[id]/[userid]/index.vue?macro=true";
import { default as index7Iv_UoRYqucLPKQ7QyWHJQVw5gsk8QfTxIjuMcBfROgMeta } from "/opt/build/repo/app/pages/invite/[id]/index.vue?macro=true";
import { default as indexyqADB48p0vuCsDMQXlKELx9zli8QH3QjrGV1tbW_pMIMeta } from "/opt/build/repo/app/pages/sendto/[id]/index.vue?macro=true";
import { default as indexQKXiUyAZxFFzO2aMVYhTmVWNAWm53VLCML3Pp_tER2UMeta } from "/opt/build/repo/app/pages/view/[srid]/index.vue?macro=true";
import { default as account_45deactivatedus_RGnW6_3wHPal1UBkpm7A_4E766WSJZzkdBTpMfQAMeta } from "/opt/build/repo/app/pages/account-deactivated.vue?macro=true";
import { default as bye91EWrr9wP4CSTsj1isOqpy5Mx8g5nsjNoKxXaHR60wwMeta } from "/opt/build/repo/app/pages/bye.vue?macro=true";
import { default as cookiesblockedg_gnKD_H8Kn_smLO93ue0yrlGxcuBcNdba1d_hvUGfMMeta } from "/opt/build/repo/app/pages/cookiesblocked.vue?macro=true";
import { default as declined8__Be3pUyEFmgKnZ6c2Jy9xlbP5bMXUh9bkO75vo0hYMeta } from "/opt/build/repo/app/pages/declined.vue?macro=true";
import { default as expiredVpVMPJyITY_i9_WFERmaBnomgeIotspxWT9KBfi9BrwMeta } from "/opt/build/repo/app/pages/expired.vue?macro=true";
import { default as loginZMDu2isPULGndDjSpo_6Ci84AtGjww61qLz8yn75KCEMeta } from "/opt/build/repo/app/pages/login.vue?macro=true";
import { default as logoutlgGOuOc9L_T_jFaL1LjvS0IK5JiIwJIapDq9lZF1n_4Meta } from "/opt/build/repo/app/pages/logout.vue?macro=true";
import { default as maintenancer7LpxzvTxl9zHGs2wE6SDxUPvfIQtHjXnVIAABOyHv8Meta } from "/opt/build/repo/app/pages/maintenance.vue?macro=true";
import { default as not_45availableSfK_AfyqKiMipwODeDtGm7jdfkeXEZI0y1QTvLf3ppYMeta } from "/opt/build/repo/app/pages/not-available.vue?macro=true";
import { default as indexE3ozRmyN36d3BCWtTMnuz6RrrvkCIGslJAyQG8yeASoMeta } from "/opt/build/repo/app/pages/password-reset/index.vue?macro=true";
import { default as planGKPj_wz_TgUMwm8am_JAWOOySDXsTwhb3OLEPKwfDkoMeta } from "/opt/build/repo/app/pages/plan.vue?macro=true";
import { default as indexplGSCvlTDwaKeFWYl4XRivCJX_u2_uuk8PwuyQ2alvQMeta } from "/opt/build/repo/app/pages/profile/index.vue?macro=true";
import { default as signedIw0_9GPljyziENtmyPKK_6T3SdtDGz8MC_aZzdAb_ewMeta } from "/opt/build/repo/app/pages/signed.vue?macro=true";
import { default as indexMuEe2Sg6Q5AbFmLn__cpPBh6F_XDflPtxxHcfNP8AR8Meta } from "/opt/build/repo/app/pages/signup/index.vue?macro=true";
import { default as sorry8sDWYl0Wo4HRywtJSN4vfHEaY488wQf92BLIVbRmz28Meta } from "/opt/build/repo/app/pages/sorry.vue?macro=true";
import { default as upgradeh3fbKp0OXe0rdQOaBwoLkCsriS6NACfCPFrdmdGhLzEMeta } from "/opt/build/repo/app/pages/upgrade.vue?macro=true";
import { default as uploadl7smne20emq_KsvawRhlhLSggmjPFjkKz2lKoW0dA8wMeta } from "/opt/build/repo/app/pages/upload.vue?macro=true";
import { default as welcomeY7BcJ6Ed9XQ6iB3yDQxHPj3TPFxbHqss8F0895_LNyMMeta } from "/opt/build/repo/app/pages/welcome.vue?macro=true";
import { default as _91_46_46_46slug_930Z8HJIhKoBgE8mhXXmcb_nV9bvyuD8u57BtNw60VkmQMeta } from "/opt/build/repo/app/pages/[...slug].vue?macro=true";
import { default as indexDRlpF_iz5XUgkm6d_USMrrBnrDkRhW19uzui_n1MZF0Meta } from "/opt/build/repo/app/pages/index.vue?macro=true";
export default [
  {
    name: "profile-signature-standards-legislation",
    path: "/profile/signature-standards/update/legislation",
    meta: legislationB7xHGN4o2fNTeFAE6etv8YXINQEcv9x7l__tiEV0X9QMeta || {},
    component: () => import("/opt/build/repo/app/pages/profile/signature-standards/update/legislation.vue")
  },
  {
    name: "signup-flows-eidplus-confirm",
    path: "/signup/flows/eidplus/confirm",
    meta: confirmS3vMEB7vO9kGKCAD9FA4WJkj93KWHbXKJEjuknw5w5MMeta || {},
    component: () => import("/opt/build/repo/app/pages/signup/flows/eidplus/confirm.vue")
  },
  {
    name: "signup-flows-eidplus-new",
    path: "/signup/flows/eidplus/new",
    meta: newQlfMnFfLDaekn69AF6Q1JpStnyNocJYgQQCHD4yrhtcMeta || {},
    component: () => import("/opt/build/repo/app/pages/signup/flows/eidplus/new.vue")
  },
  {
    name: "business-billing-plan",
    path: "/business/billing/plan",
    meta: plantN0keAE_AxfkqlvqBGvIp0zknrmv_TZwxGbbr1Z7mXQMeta || {},
    component: () => import("/opt/build/repo/app/pages/business/billing/plan.vue")
  },
  {
    name: "business-developers-api",
    path: "/business/developers/api",
    meta: api4dTCji_tursDItEokb32onoQLeQ97ZaWz9UAEm4YwAwMeta || {},
    component: () => import("/opt/build/repo/app/pages/business/developers/api.vue")
  },
  {
    name: "business-members-domains",
    path: "/business/members/domains",
    meta: domainsS_JEYm9DIccJkePnUq_RPlAz1YhjNOijNoNpXt7vkzYMeta || {},
    component: () => import("/opt/build/repo/app/pages/business/members/domains.vue")
  },
  {
    name: "business-members-groups",
    path: "/business/members/groups",
    meta: groupsT8ez152GUsY2bCL5T9bCQTRykX4BjyDr_G5danX7aI0Meta || {},
    component: () => import("/opt/build/repo/app/pages/business/members/groups.vue")
  },
  {
    name: "business-profile-aes-for-business",
    path: "/business/profile/aes-for-business",
    meta: aes_45for_45businessjizLbRHnLftjLxbX1uNK0rnO6PDeMylR968o21f3jj0Meta || {},
    component: () => import("/opt/build/repo/app/pages/business/profile/aes-for-business.vue")
  },
  {
    name: "business-signup-mail-sent",
    path: "/business/signup/mail-sent",
    meta: mail_45senth3moUOXBNXRa8eYo5VELEl584pBpA76HnfFgGMmssnIMeta || {},
    component: () => import("/opt/build/repo/app/pages/business/signup/mail-sent.vue")
  },
  {
    name: "business-signup-steps",
    path: "/business/signup/steps",
    meta: stepsFUX3gLZ95tsbuEXVA8B_jOVOd4yF1_InqDkpEYz1vVUMeta || {},
    component: () => import("/opt/build/repo/app/pages/business/signup/steps.vue")
  },
  {
    name: "ph-oauth2-login",
    path: "/ph/oauth2/login",
    meta: loginMaJG6opKGuJmnX7gWF5WIZx_849AebqLX5ZxFowE58cMeta || {},
    component: () => import("/opt/build/repo/app/pages/ph/oauth2/login.vue")
  },
  {
    name: "profile-signature-standards-update",
    path: "/profile/signature-standards/update",
    meta: indexyemt9ppC3LdvMx2eu3vH8vS3V13Ge6F_QsYQvaWGDhIMeta || {},
    component: () => import("/opt/build/repo/app/pages/profile/signature-standards/update/index.vue")
  },
  {
    name: "sso-error-company",
    path: "/sso/error/company",
    meta: companydT69o49JGr4fQaptA6qKskY6vqbuX20AY_qcK8Aq8xMMeta || {},
    component: () => import("/opt/build/repo/app/pages/sso/error/company.vue")
  },
  {
    name: "direct-sign-identification-legislation",
    path: "/direct-sign/identification/:id()/:userid()/legislation",
    meta: legislationqH81e0LrmF_bef2OyemwRvJLhpD8L1sxGGY4BS5FCNwMeta || {},
    component: () => import("/opt/build/repo/app/pages/direct-sign/identification/[id]/[userid]/legislation.vue")
  },
  {
    name: "direct-sign-identification-id-userid-preview",
    path: "/direct-sign/identification/:id()/:userid()/preview",
    meta: previewLPohnTB6589hVv8MmENilR_28aQVunSQDSXguvIhY_YMeta || {},
    component: () => import("/opt/build/repo/app/pages/direct-sign/identification/[id]/[userid]/preview.vue")
  },
  {
    name: "direct-sign-identification",
    path: "/direct-sign/identification/:id()/:userid()",
    meta: indexlWods5XMAO30KVvusm6ZvvrTw8THq3pKXLFvoLyhxAsMeta || {},
    component: () => import("/opt/build/repo/app/pages/direct-sign/identification/[id]/[userid]/index.vue")
  },
  {
    name: "business-seals-sealName",
    path: "/business/seals/:sealName()",
    meta: index7IoUENXGpqrrdwsIzkKDTzrNr54I9QyqfzXthXKkJ7YMeta || {},
    component: () => import("/opt/build/repo/app/pages/business/seals/[sealName]/index.vue")
  },
  {
    name: "business-activity",
    path: "/business/activity",
    meta: activityROuL03qpCWh55jKw8KhbMce19SA9ZlZ5VyN_X4TKMegMeta || {},
    component: () => import("/opt/build/repo/app/pages/business/activity.vue")
  },
  {
    name: "business-dashboard",
    path: "/business/dashboard",
    meta: dashboardJ_1_vtphZ_4VzI3vYVyrs50L67VxLNQse_0lXAcdJU0Meta || {},
    component: () => import("/opt/build/repo/app/pages/business/dashboard.vue")
  },
  {
    name: "business-document",
    path: "/business/document",
    meta: document3773Wnvz_u2NlCR5DoaV3rWchUeCzahGENK2O4KY8DYMeta || {},
    component: () => import("/opt/build/repo/app/pages/business/document.vue")
  },
  {
    name: "business-emails",
    path: "/business/emails",
    meta: emailsmxFS8MytxBofyYkSf5ns5tygHQppqeYKPLlt0Qeh_gIMeta || {},
    component: () => import("/opt/build/repo/app/pages/business/emails.vue")
  },
  {
    name: "business-extras",
    path: "/business/extras",
    meta: indexSkKyvbmHmfhpqPR5a4UFe0LVll3rR0LhEuqS1oaAOOMMeta || {},
    component: () => import("/opt/build/repo/app/pages/business/extras/index.vue")
  },
  {
    name: "business-members",
    path: "/business/members",
    meta: indexTZMsL7l7elYVLtWnL6aoAEHosphB_oNrEF9l5_KeDZ0Meta || {},
    component: () => import("/opt/build/repo/app/pages/business/members/index.vue")
  },
  {
    name: "business-profile",
    path: "/business/profile",
    meta: index1Wyi6_rtlA2LSrM2UtLB_Mn9VY6Mh94fLaOK6IRyJTMMeta || {},
    component: () => import("/opt/build/repo/app/pages/business/profile/index.vue")
  },
  {
    name: "business-register",
    path: "/business/register",
    meta: indexkwwdiWe3omfo9IOyv_hL57560B0_3SL5k3Jqxp6M0KMMeta || {},
    component: () => import("/opt/build/repo/app/pages/business/register/index.vue")
  },
  {
    name: "business-seals",
    path: "/business/seals",
    meta: indexPWG6FpuX9nBE1hF2hCqQ8v0x3b8tGk09Oo3g1rKXU7QMeta || {},
    component: () => import("/opt/build/repo/app/pages/business/seals/index.vue")
  },
  {
    name: "business-signup",
    path: "/business/signup",
    meta: indexA_ZNRxEgO0N2PCbq166XTDdFgBuy9PhPVuORc0Ci4gEMeta || {},
    component: () => import("/opt/build/repo/app/pages/business/signup/index.vue")
  },
  {
    name: "business-upgrade",
    path: "/business/upgrade",
    meta: upgrade1vDoNUkm30P_dTERr2wSkAzF_At0JUzwFCCZlbqNzCYMeta || {},
    component: () => import("/opt/build/repo/app/pages/business/upgrade.vue")
  },
  {
    name: "business-welcome",
    path: "/business/welcome",
    meta: welcomebhNxlhDiu7xxZiLYo9PZ4_u06FeEW_P7ulzRlrGPRO0Meta || {},
    component: () => import("/opt/build/repo/app/pages/business/welcome.vue")
  },
  {
    name: "mab-redirect",
    path: "/mab/redirect",
    meta: redirectj2uDdkxIVHXABqZTbZWfbzd6jwrP5WAKJK0E0Q_ePAYMeta || {},
    component: () => import("/opt/build/repo/app/pages/mab/redirect.vue")
  },
  {
    name: "mab-redirect-ident",
    path: "/mab/redirect-ident",
    meta: redirect_45identiV2HR8MNR0BGj5b6EQKhH75yFioskMt5snaT6wi3U_IMeta || {},
    component: () => import("/opt/build/repo/app/pages/mab/redirect-ident.vue")
  },
  {
    name: "password-reset-confirm",
    path: "/password-reset/confirm",
    meta: confirm_LylbhKtP_Q_d2NYPB0dX7Ne6MZkSJYke5cKm6cOa6IMeta || {},
    component: () => import("/opt/build/repo/app/pages/password-reset/confirm.vue")
  },
  {
    name: "password-reset-mail-sent",
    path: "/password-reset/mail-sent",
    meta: mail_45sentb_W1BbAqJJ2B06XPLGRjjYdD5e9Sd0c2qHd_G9MnE0IMeta || {},
    component: () => import("/opt/build/repo/app/pages/password-reset/mail-sent.vue")
  },
  {
    name: "password-reset-new",
    path: "/password-reset/new",
    meta: new64QfEf_N3xlluf_a6HOiq1_3niD8x4Cl0lCYbjGDQFsMeta || {},
    component: () => import("/opt/build/repo/app/pages/password-reset/new.vue")
  },
  {
    name: "profile-change-password",
    path: "/profile/change-password",
    meta: change_45passwordnXlavpNCIWga8k4arM6wsPhbipAePLOA6KIPDOGodX4Meta || {},
    component: () => import("/opt/build/repo/app/pages/profile/change-password.vue")
  },
  {
    name: "profile-confirm",
    path: "/profile/confirm",
    meta: confirmeRm5AU7EyBPGVdDb6Kg6__y_pbeD6Hd6mgqqruQVcNAMeta || {},
    component: () => import("/opt/build/repo/app/pages/profile/confirm.vue")
  },
  {
    name: "profile-settings",
    path: "/profile/settings",
    meta: settingsk2wl4ftyrvYKnjCI5Mgi_p4ltFfzdC06QKqVKwBgi6UMeta || {},
    component: () => import("/opt/build/repo/app/pages/profile/settings.vue")
  },
  {
    name: "profile-signature-standards",
    path: "/profile/signature-standards",
    meta: indexw8qEYFGX2Ed8XSCZojzZaTMPRbKDeGiM6XQxoXrSXjoMeta || {},
    component: () => import("/opt/build/repo/app/pages/profile/signature-standards/index.vue")
  },
  {
    name: "profile-visual-signature",
    path: "/profile/visual-signature",
    meta: visual_45signature6xNFbiUTpmWEFWQrpeEtizvKDHNfCjRHolj_xcYgkjYMeta || {},
    component: () => import("/opt/build/repo/app/pages/profile/visual-signature.vue")
  },
  {
    name: "signup-confirm",
    path: "/signup/confirm",
    meta: confirm45xOteHgwbcOFGnDIApqnniVSM_O7jMXLmcrijrtdHYMeta || {},
    component: () => import("/opt/build/repo/app/pages/signup/confirm.vue")
  },
  {
    name: "signup-mail-sent",
    path: "/signup/mail-sent",
    meta: mail_45sentiSdN6bqcb6ysDQ3B9CNCNFkiawaEo9xGtmjv0TQ_iHsMeta || {},
    component: () => import("/opt/build/repo/app/pages/signup/mail-sent.vue")
  },
  {
    name: "signup-sso",
    path: "/signup/sso",
    meta: ssoFfrxxRpULCuYoytW4yTfXh_e_G4KQ6Xy_xranu5frZkMeta || {},
    component: () => import("/opt/build/repo/app/pages/signup/sso.vue")
  },
  {
    name: "signup-starter",
    path: "/signup/starter",
    meta: indexSXhqIe3gXX2XTh5AdmbvZ6BMu21pWxM1FJWjg7hDGb4Meta || {},
    component: () => import("/opt/build/repo/app/pages/signup/starter/index.vue")
  },
  {
    name: "signup-steps",
    path: "/signup/steps",
    meta: stepsPGOW6gaf3jzTsv48e68HfiDHhBezwcgspo4wWmO3Jq8Meta || {},
    component: () => import("/opt/build/repo/app/pages/signup/steps.vue")
  },
  {
    name: "sso-error",
    path: "/sso/error",
    meta: indexxi1YGsm8LBuD4U6hkxyi3VA21_mjzYpmTBdlzZ33t2sMeta || {},
    component: () => import("/opt/build/repo/app/pages/sso/error/index.vue")
  },
  {
    name: "starter-register",
    path: "/starter/register",
    meta: indexLqy26eFGIrE_oImypaxaw74IxlL7HEKg_eepufJdPscMeta || {},
    component: () => import("/opt/build/repo/app/pages/starter/register/index.vue")
  },
  {
    name: "view-id-userid",
    path: "/view/:id()/:userid()",
    meta: indexPnsekB5wUISULu1ger1g7EE89aa9uBOxXSy9p2Z66gIMeta || {},
    component: () => import("/opt/build/repo/app/pages/view/[id]/[userid]/index.vue")
  },
  {
    name: "invite-id",
    path: "/invite/:id()",
    meta: index7Iv_UoRYqucLPKQ7QyWHJQVw5gsk8QfTxIjuMcBfROgMeta || {},
    component: () => import("/opt/build/repo/app/pages/invite/[id]/index.vue")
  },
  {
    name: "sendto-id",
    path: "/sendto/:id()",
    meta: indexyqADB48p0vuCsDMQXlKELx9zli8QH3QjrGV1tbW_pMIMeta || {},
    component: () => import("/opt/build/repo/app/pages/sendto/[id]/index.vue")
  },
  {
    name: "view-srid",
    path: "/view/:srid()",
    meta: indexQKXiUyAZxFFzO2aMVYhTmVWNAWm53VLCML3Pp_tER2UMeta || {},
    component: () => import("/opt/build/repo/app/pages/view/[srid]/index.vue")
  },
  {
    name: "account-deactivated",
    path: "/account-deactivated",
    meta: account_45deactivatedus_RGnW6_3wHPal1UBkpm7A_4E766WSJZzkdBTpMfQAMeta || {},
    component: () => import("/opt/build/repo/app/pages/account-deactivated.vue")
  },
  {
    name: "bye",
    path: "/bye",
    meta: bye91EWrr9wP4CSTsj1isOqpy5Mx8g5nsjNoKxXaHR60wwMeta || {},
    component: () => import("/opt/build/repo/app/pages/bye.vue")
  },
  {
    name: "cookiesblocked",
    path: "/cookiesblocked",
    meta: cookiesblockedg_gnKD_H8Kn_smLO93ue0yrlGxcuBcNdba1d_hvUGfMMeta || {},
    component: () => import("/opt/build/repo/app/pages/cookiesblocked.vue")
  },
  {
    name: "declined",
    path: "/declined",
    meta: declined8__Be3pUyEFmgKnZ6c2Jy9xlbP5bMXUh9bkO75vo0hYMeta || {},
    component: () => import("/opt/build/repo/app/pages/declined.vue")
  },
  {
    name: "expired",
    path: "/expired",
    meta: expiredVpVMPJyITY_i9_WFERmaBnomgeIotspxWT9KBfi9BrwMeta || {},
    component: () => import("/opt/build/repo/app/pages/expired.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginZMDu2isPULGndDjSpo_6Ci84AtGjww61qLz8yn75KCEMeta || {},
    component: () => import("/opt/build/repo/app/pages/login.vue")
  },
  {
    name: "logout",
    path: "/logout",
    meta: logoutlgGOuOc9L_T_jFaL1LjvS0IK5JiIwJIapDq9lZF1n_4Meta || {},
    component: () => import("/opt/build/repo/app/pages/logout.vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    meta: maintenancer7LpxzvTxl9zHGs2wE6SDxUPvfIQtHjXnVIAABOyHv8Meta || {},
    component: () => import("/opt/build/repo/app/pages/maintenance.vue")
  },
  {
    name: "not-available",
    path: "/not-available",
    meta: not_45availableSfK_AfyqKiMipwODeDtGm7jdfkeXEZI0y1QTvLf3ppYMeta || {},
    component: () => import("/opt/build/repo/app/pages/not-available.vue")
  },
  {
    name: "password-reset",
    path: "/password-reset",
    meta: indexE3ozRmyN36d3BCWtTMnuz6RrrvkCIGslJAyQG8yeASoMeta || {},
    component: () => import("/opt/build/repo/app/pages/password-reset/index.vue")
  },
  {
    name: "plan",
    path: "/plan",
    meta: planGKPj_wz_TgUMwm8am_JAWOOySDXsTwhb3OLEPKwfDkoMeta || {},
    component: () => import("/opt/build/repo/app/pages/plan.vue")
  },
  {
    name: "profile",
    path: "/profile",
    meta: indexplGSCvlTDwaKeFWYl4XRivCJX_u2_uuk8PwuyQ2alvQMeta || {},
    component: () => import("/opt/build/repo/app/pages/profile/index.vue")
  },
  {
    name: "signed",
    path: "/signed",
    meta: signedIw0_9GPljyziENtmyPKK_6T3SdtDGz8MC_aZzdAb_ewMeta || {},
    component: () => import("/opt/build/repo/app/pages/signed.vue")
  },
  {
    name: "signup",
    path: "/signup",
    meta: indexMuEe2Sg6Q5AbFmLn__cpPBh6F_XDflPtxxHcfNP8AR8Meta || {},
    component: () => import("/opt/build/repo/app/pages/signup/index.vue")
  },
  {
    name: "sorry",
    path: "/sorry",
    meta: sorry8sDWYl0Wo4HRywtJSN4vfHEaY488wQf92BLIVbRmz28Meta || {},
    component: () => import("/opt/build/repo/app/pages/sorry.vue")
  },
  {
    name: "upgrade",
    path: "/upgrade",
    meta: upgradeh3fbKp0OXe0rdQOaBwoLkCsriS6NACfCPFrdmdGhLzEMeta || {},
    component: () => import("/opt/build/repo/app/pages/upgrade.vue")
  },
  {
    name: "upload",
    path: "/upload",
    meta: uploadl7smne20emq_KsvawRhlhLSggmjPFjkKz2lKoW0dA8wMeta || {},
    component: () => import("/opt/build/repo/app/pages/upload.vue")
  },
  {
    name: "welcome",
    path: "/welcome",
    meta: welcomeY7BcJ6Ed9XQ6iB3yDQxHPj3TPFxbHqss8F0895_LNyMMeta || {},
    component: () => import("/opt/build/repo/app/pages/welcome.vue")
  },
  {
    name: "404",
    path: "/:slug(.*)*",
    meta: _91_46_46_46slug_930Z8HJIhKoBgE8mhXXmcb_nV9bvyuD8u57BtNw60VkmQMeta || {},
    component: () => import("/opt/build/repo/app/pages/[...slug].vue")
  },
  {
    name: "index",
    path: "/dashboard",
    meta: indexDRlpF_iz5XUgkm6d_USMrrBnrDkRhW19uzui_n1MZF0Meta || {},
    alias: ["/"],
    component: () => import("/opt/build/repo/app/pages/index.vue")
  }
]